<div class="device-map-widget" [class.expanded]="expanded()" [attr.role]="expanded() ? 'dialog' : null" [attr.aria-modal]="expanded() ? 'true' : null" [attr.aria-label]="expanded() ? 'System map' : null">
    <div class="map-header">
        <h4>
            <fa-icon icon="map-location-dot"></fa-icon>
            System Locations
            @if (locationCount() > 0) {
                <span class="device-count">{{ locationCount() }} {{ locationCount() === 1 ? 'system' : 'systems' }}</span>
            }
        </h4>
        <button type="button" class="expand-button" [attr.aria-label]="expanded() ? 'Close expanded map' : 'Expand map'" [pTooltip]="expanded() ? 'Close (Esc)' : 'Expand map'" tooltipPosition="left" (click)="toggleExpanded()">
            <fa-icon [icon]="expanded() ? 'xmark' : 'expand'"></fa-icon>
        </button>
    </div>

    <div class="map-body">
        @if (expanded()) {
            <aside class="system-panel" aria-label="Systems on the map">
                <label class="system-search">
                    <i class="pi pi-search" aria-hidden="true"></i>
                    <input pInputText type="search" aria-label="Search systems" placeholder="Search systems or addresses" [ngModel]="search()" (ngModelChange)="search.set($event)" />
                </label>
                <div class="status-filters" role="group" aria-label="Filter by status">
                    <button type="button" [class.active]="statusFilter() === 'all'" [attr.aria-pressed]="statusFilter() === 'all'" (click)="statusFilter.set('all')">
                        All <strong>{{ locationCount() }}</strong>
                    </button>
                    <button type="button" [class.active]="statusFilter() === 'active'" [attr.aria-pressed]="statusFilter() === 'active'" (click)="statusFilter.set('active')">
                        <span class="status-dot ok" aria-hidden="true"></span>Active <strong>{{ activeCount() }}</strong>
                    </button>
                    <button type="button" [class.active]="statusFilter() === 'attention'" [attr.aria-pressed]="statusFilter() === 'attention'" (click)="statusFilter.set('attention')">
                        <span class="status-dot error" aria-hidden="true"></span>Other <strong>{{ attentionCount() }}</strong>
                    </button>
                </div>
                <ul class="system-list">
                    @for (d of filteredLocations(); track d.deviceId) {
                        <li>
                            <button type="button" class="system-item" [class.selected]="selectedId() === d.deviceId" [attr.aria-current]="selectedId() === d.deviceId ? 'true' : null" (click)="selectDevice(d)">
                                <span class="status-dot" [ngClass]="statusTone(d.status)" aria-hidden="true"></span>
                                <span class="system-text">
                                    <span class="system-name">{{ d.deviceName }}</span>
                                    <span class="system-meta">{{ statusMeta(d) }}</span>
                                    @if (d.address) {
                                        <span class="system-meta">{{ d.address }}</span>
                                    }
                                </span>
                            </button>
                            <button type="button" class="system-open" [attr.aria-label]="'Open ' + d.deviceName" pTooltip="Open system" tooltipPosition="left" (click)="openDevice(d.deviceId)">
                                <i class="pi pi-arrow-right" aria-hidden="true"></i>
                            </button>
                        </li>
                    } @empty {
                        <li class="system-empty">No systems match.</li>
                    }
                </ul>
            </aside>
        }

        <div class="map-content">
            <!-- Always render map container so it persists across location changes and expand/collapse -->
            <div #mapContainer class="map-container"></div>

            @if (loading()) {
                <div class="map-overlay">
                    <p-progressspinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" ariaLabel="Loading map"></p-progressspinner>
                </div>
            } @else if (error()) {
                <div class="map-overlay">
                    <app-empty-state icon="pi pi-exclamation-circle" tone="error" title="Couldn't load the map" [description]="error()" [compact]="true" />
                </div>
            } @else if (!hasLocations()) {
                <div class="map-overlay">
                    <app-empty-state icon="pi pi-map-marker" title="No system locations yet" description="Systems appear here once they report a public IP, or when you set a location on the system's page." [compact]="true" />
                </div>
            }

            @if (!loading() && !error() && hasLocations() && hiddenCount() > 0) {
                <button type="button" class="more-indicator" (click)="setExpanded(true)">+{{ hiddenCount() }} more systems — expand to see all</button>
            }
        </div>
    </div>
</div>
